import { render } from "./TubeImageCatalogueComponent.vue?vue&type=template&id=34eab695&scoped=true"
import script from "./TubeImageCatalogueComponent.vue?vue&type=script&lang=js"
export * from "./TubeImageCatalogueComponent.vue?vue&type=script&lang=js"

import "./TubeImageCatalogueComponent.vue?vue&type=style&index=0&id=34eab695&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34eab695"]])

export default __exports__